import { render } from "./post-page.vue?vue&type=template&id=90de08b4"
import script from "./post-page.vue?vue&type=script&lang=js"
export * from "./post-page.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__